import i18next, { Resource } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { i18nLanguage } from 'tccc-utils';
import en from 'tccc-i18n/translations/en-US.json';
import zh from 'tccc-i18n/translations/zh-CN.json';

const resources: Resource = {
  en: {
    translations: en,
  },
  zh: {
    translations: zh,
  },
};
i18next.use(LanguageDetector).init({
  fallbackLng: 'en',
  defaultNS: 'translations',
  lng: i18nLanguage.language,
  resources,
});
export default i18next;
